module.exports = __webpack_public_path__ + "img/content_all2.3b4e4a46.png";